export * from './MediaUiAPauseShapeIcon';
export * from './MediaUiAPauseShapeIcon16Light';
export * from './MediaUiAPauseShapeIcon16Regular';
export * from './MediaUiAPauseShapeIcon16Solid';
export * from './MediaUiAPauseShapeIcon20Light';
export * from './MediaUiAPauseShapeIcon20Regular';
export * from './MediaUiAPauseShapeIcon20Solid';
export * from './MediaUiAPauseShapeIcon24Regular';
export * from './MediaUiAPauseShapeIcon24Solid';
export * from './MediaUiAPauseShapeIcon32Regular';
export * from './MediaUiAPauseShapeIcon64Regular';
